import { DownloadOutlined } from "@ant-design/icons";
import AccessControl from "components/common/AccessControl/accessControl";
import ManageAccess from "components/common/ManageAccess/manageAccess";
import {
  BasicInfo,
  Datafeed,
  Features,
  OperationsOp,
  Security,
  SettingOP,
  SocialAOp,
  UsersOp,
  WorkplaceOp,
} from "components/icons";
import { allUserRoles, cdRoles, ENTITY_TYPE, ROLE, userRoleType } from "constants/phase";
import { cloneDeep, get } from "lodash";
import React, { useEffect, useState } from "react";
import { Link, useNavigate, useOutletContext, useParams } from "react-router-dom";

import { getEntityType } from "../../../helpers";
import SettingSideBar from "./SettingSideBar";
const SideBar = (props) => {
  const navigate = useNavigate();
  const { id } = useParams();
  const { currentRole } = useOutletContext();
  const {
    userData,
    currentItem,
    parentClientSetting,
    clientSetting,
    setCurrentItem,
    active_tab,
    active,
    setActive,
    getOrganizationUsers,
    getWorkspaces,
    getWorkspaceUsers,
    getClientSetting,
  } = props;
  const [usersCount, setUsersCount] = useState(0);
  const [wsCount, setWsCount] = useState(0);
  const [configurationOptions, setConfigurationOptions] = useState([
    {
      name: "Basic Information",
      dbKey: "basicInfo",
      key: "basicinfo",
      accessKey: "view_basic_information",
      item: <BasicInfo />,
      allowedAccess: [ENTITY_TYPE.ORGANIZATION, ENTITY_TYPE.WORKSPACES],
    },
    {
      name: "Features",
      dbKey: "features",
      key: "features",
      accessKey: "view_feature",
      item: <Features />,
      allowedAccess: [ENTITY_TYPE.ORGANIZATION, ENTITY_TYPE.WORKSPACES],
    },
    {
      name: "Users",
      dbKey: "users",
      key: "users",
      accessKey: "view_user",
      item: <UsersOp />,
      allowedAccess: [ENTITY_TYPE.ORGANIZATION, ENTITY_TYPE.WORKSPACES],
    },
    {
      name: "Workspaces",
      dbKey: "workSpaces",
      key: "workSpaces",
      accessKey: "view_workSpaces",
      item: <WorkplaceOp />,
      allowedAccess: [ENTITY_TYPE.ORGANIZATION],
    },
    {
      name: "Media content",
      dbKey: "mediaContent",
      key: "mediaContent",
      accessKey: "view_media_content",
      item: <WorkplaceOp />,
      allowedAccess: [ENTITY_TYPE.ORGANIZATION, ENTITY_TYPE.WORKSPACES],
    },
    {
      name: "Social Accounts",
      key: "socialAccounts",
      dbKey: "socialAccounts",
      accessKey: "view_socialAccounts",
      item: <SocialAOp />,
      allowedAccess: [ENTITY_TYPE.ORGANIZATION, ENTITY_TYPE.WORKSPACES],
    },
    {
      name: "Settings",
      key: "settings",
      dbKey: "settings",
      accessKey: "view_settings",
      item: <SettingOP />,
      allowedAccess: [ENTITY_TYPE.ORGANIZATION, ENTITY_TYPE.WORKSPACES],
    },
    {
      name: "Security",
      key: "security",
      dbKey: "security",
      accessKey: "view_security",
      item: <Security />,
      allowedAccess: [ENTITY_TYPE.ORGANIZATION, ENTITY_TYPE.WORKSPACES],
    },
    {
      name: "Operations",
      key: "operations",
      dbKey: "operations",
      accessKey: "view_operations",
      item: <OperationsOp />,
      allowedAccess: [ENTITY_TYPE.ORGANIZATION, ENTITY_TYPE.WORKSPACES],
    },
    {
      name: "Datafeed Config",
      key: "datafeed",
      dbKey: "datafeed",
      accessKey: "view_datafeed",
      item: <Datafeed />,
      allowedAccess: [ENTITY_TYPE.ORGANIZATION, ENTITY_TYPE.WORKSPACES],
    },
    {
      name: "Plans",
      key: "plans",
      dbKey: "view_plans",
      accessKey: "view_plans",
      item: <OperationsOp />,
      allowedAccess: [ENTITY_TYPE.ORGANIZATION, ENTITY_TYPE.WORKSPACES],
    },
  ]);

  const fetchCounts = async () => {
    try {
      // To fetch user counts
      if (id.startsWith("org")) {
        const payload = {
          organizationId: id,
          pageSize: 5,
          page: 1,
          search: "",
        };
        if (userData?.role !== ROLE.SUPER_ADMIN) {
          payload.roleType = userRoleType.client;
        }
        const response = await getOrganizationUsers(payload);
        if (response?.value?.status) {
          setUsersCount(response?.value?.total);
        }
      } else if (id.startsWith("ws")) {
        const response = await getWorkspaceUsers({
          workspaceId: id,
          // role: currentRole,
          pageSize: 5,
          page: 1,
          search: "",
        });

        if (response?.value?.status) {
          setUsersCount(response?.value?.total);
        }
      }
      // To fetch Org counts
      if (id.startsWith("org")) {
        let payloadCount = {
          page: 1,
          pageSize: 5,
          search: "",
        };
        if (id) {
          // this is only true when coming from profile page
          payloadCount.organizationId = id;
        }
        const responseWorkspace = await getWorkspaces(payloadCount);
        if (responseWorkspace?.value?.status) {
          setWsCount(responseWorkspace?.value?.total);
        }
      }
    } catch (error) {
      console.log("Errorr");
    }
  };
  useEffect(() => {
    fetchCounts();
  }, [id]);

  const onLinkChange = (item) => {
    if (item?.key === "settings") {
    }
    setCurrentItem({ name: item.name, key: item.key });
    if (currentItem?.key !== item.key) {
      if (ENTITY_TYPE.ORGANIZATION === getEntityType(id)) {
        navigate(`/organizations-profile/${id}/${item?.key}`, { replace: true });
      } else {
        navigate(`/workspaces-profile/${id}/${item?.key}`, { replace: true });
      }
    }
    if (active == true && item?.key === "settings") {
      if (ENTITY_TYPE.ORGANIZATION === getEntityType(id)) {
        navigate(`/organizations-profile/${id}/${"basicinfo"}`, { replace: true });
      } else {
        navigate(`/workspaces-profile/${id}/${"basicinfo"}`, { replace: true });
      }
      setActive(false);
    }

    if (item?.key === "settings" && active == false) {
      setActive(true);
      if (ENTITY_TYPE.ORGANIZATION === getEntityType(id)) {
        navigate(`/organizations-profile/${id}/${"category"}`, { replace: true });
      } else {
        navigate(`/workspaces-profile/${id}/${"category"}`, { replace: true });
      }
    }
  };
  useEffect(() => {
    let configuration = cloneDeep(configurationOptions);
    let manageDownload = {
      name: "Manage download limit",
      key: "manageDownloadLimit",
      dbKey: "manageDownloadLimit",
      accessKey: "manage_download_limit",
      item: <DownloadOutlined />,
      allowedAccess: [ENTITY_TYPE.ORGANIZATION],
    };
    if (currentRole) {
      configuration = configuration.filter((data) => {
        if (
          currentRole === allUserRoles.superAdmin ||
          currentRole === allUserRoles.admin ||
          currentRole === allUserRoles.user ||
          currentRole === allUserRoles.reviewer ||
          Object.values(cdRoles).includes(currentRole)
        ) {
          return true;
        } else if (
          parentClientSetting?.permissions?.reviewerFunctionality &&
          get(clientSetting, `permissions.${data.dbKey}`, false) &&
          currentRole === allUserRoles.user
        ) {
          return true;
        }
      });
      const hasManageDownloadLimit = configuration?.some((data) => data?.key === "manageDownloadLimit");
      if (!hasManageDownloadLimit && clientSetting?.permissions?.manageDownloadLimit) {
        configuration.push(manageDownload);
      }
      configuration = configuration.map((data) => {
        if (data.key === "users") {
          return {
            ...data,
            name: `Users (${usersCount})`,
          };
        } else if (data.key === "workSpaces") {
          return {
            ...data,
            name: `Workspaces (${wsCount})`,
          };
        }
        return data;
      });
      if (configuration && configuration.length) {
        setCurrentItem({ name: configuration[0].name, key: configuration[0].key });
      }
      setConfigurationOptions(configuration);
    }
  }, [currentRole, wsCount, usersCount]);
  useEffect(() => {
    if (
      active_tab !==
      ("basicinfo" ||
        "features" ||
        "users" ||
        "datafeed" ||
        "workSpaces" ||
        "socialAccounts" ||
        "operations" ||
        "plans" ||
        "manageDownloadLimit")
    ) {
      setActive(true);
    }
  }, []);
  return (
    <>
      {configurationOptions?.length > 0 && (
        <div className="left-block--op">
          <ul>
            {configurationOptions.map((item, index) => (
              <AccessControl key={index} code={item.accessKey} page="organization-profile">
                <ManageAccess value={item.allowedAccess.includes(getEntityType(id))}>
                  <li className={active_tab === item.key ? "active" : ""}>
                    <div className="mc-op--block">
                      <Link
                        to={
                          active && item?.key === "settings"
                            ? `/${ENTITY_TYPE.ORGANIZATION === getEntityType(id) ? "organizations" : "workspaces"}-profile/${id}/${"basicinfo"}`
                            : item?.key === "settings" && !active
                              ? `/${ENTITY_TYPE.ORGANIZATION === getEntityType(id) ? "organizations" : "workspaces"}-profile/${id}/${userData?.role === ROLE.SUPER_ADMIN ? "customFields" : "category"}`
                              : `/${ENTITY_TYPE.ORGANIZATION === getEntityType(id) ? "organizations" : "workspaces"}-profile/${id}/${item?.key}`
                        }
                        onClick={() => {
                          onLinkChange(item);
                        }}
                        className={active_tab === item.key ? "active" : ""}
                        replace
                      >
                        {item.item}
                        {item.name}
                      </Link>
                      {item.key === "settings" && active && (
                        <div className="mcop-dropdown--menu">
                          <SettingSideBar
                            userData={userData}
                            currentItem={currentItem}
                            parentClientSetting={parentClientSetting}
                            clientSetting={clientSetting}
                            setCurrentItem={setCurrentItem}
                            active_tab={active_tab}
                            active={active}
                            setActive={setActive}
                            getClientSetting={getClientSetting}
                          />
                        </div>
                      )}
                    </div>
                  </li>
                </ManageAccess>
              </AccessControl>
            ))}
          </ul>
        </div>
      )}
    </>
  );
};

export default SideBar;
